export default __webpack_public_path__ + "static/media/7B1_1976-11-1.b8f7376c.png";